// extracted by mini-css-extract-plugin
module.exports = {"title_box":"FormCard_title_box__2V32P","title_card":"FormCard_title_card__13LI8","card_info":"FormCard_card_info__2xtoF"};